import { ResourceType } from '../../enumerations/ResourceType';
import { ParentedArtifactResource } from '../artifactResourceTypes';
import { AddOrSetMutateObjectWithParentRelation, AddOrSetMutateObjectWithParentRelationSchema } from '../mutateObjects';
import { PersistableSchemaType } from '../persistableResourceTypes';
import { useMutationWithDelay } from '../useMutationWithDelay';
import { useMultiAndSingleResourceMultiParentedResourceAdapterBaseActions } from './useMultiAndSingleResourceMultiParentedResourceAdapterBaseActions';

export function useMultiAndSingleResourceMultiParentedResourceAdapterActions<R extends ParentedArtifactResource>(
    apiPostfix: string,
    resourceType: ResourceType,
    resourceSchema: PersistableSchemaType<R>
) {
    const actions = useMultiAndSingleResourceMultiParentedResourceAdapterBaseActions(apiPostfix, resourceType, resourceSchema);

    const useSetResource = () => {
        return useMutationWithDelay(
            (mutateObject: AddOrSetMutateObjectWithParentRelation<R>) =>
                actions.addOrSetResource(mutateObject.resource, mutateObject.parentId as string, mutateObject.parentRelation),
            AddOrSetMutateObjectWithParentRelationSchema
        );
    };

    const useAddResource = () => {
        return useMutationWithDelay(
            (mutateObject: AddOrSetMutateObjectWithParentRelation<R>) =>
                actions.addOrSetResource(mutateObject.resource, mutateObject.parentId as string, mutateObject.parentRelation),
            AddOrSetMutateObjectWithParentRelationSchema
        );
    };

    return {
        useValidateResource: actions.useValidateResource,
        useValidateAllResourcesMultiParented: actions.useValidateAllResourcesMultiParented,
        useValidateAllResourcesSingleParented: actions.useValidateAllResourcesSingleParented,
        useGetResource: actions.useGetResource,
        useUpdateResource: actions.useUpdateResource,
        useDeleteResource: actions.useDeleteResource,
        useGetAllOrSingleResources: actions.useGetAllOrSingleResources,
        useGetAllResources: actions.useGetAllResources,
        useGetSingleResource: actions.useGetSingleResource,
        processMutationResponse: actions.processMutationResponse,
        processGetResponse: actions.processGetResponse,
        processGetCollectionResponse: actions.processGetCollectionResponse,
        processGetResourceResponse: actions.processGetResourceResponse,
        useSetResource,
        useAddResource,
    };
}
